import { useCallback, useState } from 'react';

type ModalState<T> = { open: false; modalData: undefined } | { open: true; modalData: T };

function useFullModalState<T>() {
    const [state, setState] = useState<ModalState<T>>({ open: false, modalData: undefined });

    const openModal = useCallback((modalData: T) => {
        setState({ open: true, modalData });
    }, []);

    const closeModal = useCallback(() => {
        setState({
            open: false,
            modalData: undefined,
        });
    }, []);

    return { ...state, openModal, closeModal };
}

export default useFullModalState;
